// src/components/inbox/DocumentsTab.jsx
import React from "react";
import { Button } from "../ui";
import {
  privacyNoticeLine,
  safeHttpUrl,
  shortName,
  uploadMeta,
} from "./inboxFormat";

// What the client uploaded, newest first, from the thread or the Documents
// page. "View" renders only when the server resolved a link (the vault is
// unreachable on a machine without its credentials, so url is null there).
export default function DocumentsTab({ documents, client }) {
  const uploads = documents.uploads || [];
  return (
    <div className="tw-flex tw-flex-col tw-gap-4 tw-p-4">
      <div className="tw-flex tw-flex-col tw-gap-1">
        <h3 className="tw-m-0 tw-text-lg tw-font-bold tw-text-text">{`Documents · ${shortName(client)}`}</h3>
        <p className="tw-m-0 tw-text-xs tw-text-text-muted">What the client uploaded.</p>
      </div>

      <div className="tw-grid tw-gap-2">
        <div className="tw-text-xs tw-font-bold tw-uppercase tw-text-text-muted">{`Uploaded by ${client?.firstName ?? ""}`}</div>
        {uploads.length > 0 ? (
          <ul className="tw-m-0 tw-list-none tw-p-0">
            {uploads.map((u) => {
              const href = safeHttpUrl(u.url);
              return (
                <li key={u.documentId} className="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-border-0 tw-border-b tw-border-solid tw-border-divider tw-py-2 tw-text-sm last:tw-border-b-0">
                  <div>
                    <div>{u.filename}</div>
                    <div className="tw-m-0 tw-text-xs tw-text-text-muted">{uploadMeta(u)}</div>
                  </div>
                  {href && (
                    <Button
                      as="a"
                      variant="text"
                      size="sm"
                      href={href}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View
                    </Button>
                  )}
                </li>
              );
            })}
          </ul>
        ) : (
          <p className="tw-m-0 tw-rounded-md tw-border tw-border-dashed tw-border-divider tw-px-3 tw-py-2 tw-text-sm tw-text-text-muted">Nothing uploaded yet.</p>
        )}
      </div>

      <div className="tw-grid tw-gap-2">
        <div className="tw-text-xs tw-font-bold tw-uppercase tw-text-text-muted">Consents</div>
        {/* SP3: read from the client's Privacy Notice delivery record. */}
        <div className="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-border-0 tw-border-b tw-border-solid tw-border-divider tw-py-2 tw-text-sm last:tw-border-b-0">
          <span>{privacyNoticeLine(documents.privacyNotice)}</span>
        </div>
      </div>

      <p className="tw-m-0 tw-text-xs tw-text-text-muted">
        Not held by the app: signed agreements, document requests, reminders.
      </p>
    </div>
  );
}
